import { Box, Divider, Stack, Step, StepConnector, StepLabel, Stepper, Typography } from '@mui/material';
import { getStepConnectorUtilityClass } from '@mui/material/StepConnector';
import React, { useEffect, useMemo } from 'react';
import styled, { useTheme } from 'styled-components';
import AbsForm, { ConfigType } from "../../abstract/Form";
import CardWithHeader from '../../components/cards/CardWithHeader';
import FileUploadButton2 from '../../components/inputs/FileUploadButton2';
import { FormProvider, useFormContext } from '../../contexts/FormContext';
import theme from '../../theme';
import { toKebabCase } from '../../utils';
import { config } from './config';
import { schema } from './types';
import { useNavigate } from 'react-router-dom';
import { useApp } from '../../contexts/AppContext';

interface HormonicalProtocolsFormProps {
}

type FormNavigationItemStatus = "empty" | "complete" | "incomplete";

interface FormNavigationItem {
    label: string;
    id: string;
    status: FormNavigationItemStatus;
}

const CustomConnector = styled(StepConnector)(({ theme }) => ({
    [`& .${getStepConnectorUtilityClass('line')}`]: {
        borderColor: '#DDD6FE', // Set the color of the line
        //   borderTopWidth: 4, // Set the thickness of the line
        //   borderRadius: 2,
        borderWidth: 3,
    },
}));

const FormNavigationStepCircleEmpty: React.FC = () => {
    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#FFFFFF',
                border: '2px dashed #DDD6FE'
            }}
        />
    );
}

const FormNavigationStepCircleIncomplete: React.FC = () => {
    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                background: 'conic-gradient(#DDD6FE 0deg 180deg, #ffffff 180deg 360deg);',
                border: '2px solid #DDD6FE',
            }}
        />
    );
}

const FormNavigationStepCircleComplete: React.FC = () => {
    return (
        <Box
            sx={{
                width: 24,
                height: 24,
                borderRadius: '50%',
                backgroundColor: '#DDD6FE',
            }}
        />
    );
}

const formNavigationCircleByStatus = (status: FormNavigationItemStatus) => {

    switch (status) {
        case "empty":
            return FormNavigationStepCircleEmpty;
        case "complete":
            return FormNavigationStepCircleComplete;
        case "incomplete":
            return FormNavigationStepCircleIncomplete;
    }

}

const StyledStepper = styled(Stepper)`
    & .active {
        background-color: #DDD6FE;
    }
`;

const FormNavigation: React.FC<{ config: ConfigType }> = ({ config }) => {

    const { updateCurrentSection, currentSection } = useFormContext();
    const { updateBreadcrumbs, updateActions } = useApp();
    const navigate = useNavigate();

    useEffect(() => {
        updateBreadcrumbs([{
            label: "Hormonal Protocol", onClick: () => {
                navigate("/hormone-protocols");
            }
        }, {
            label: "New Cycle Form"
        }]);
    }, []);


    const items = useMemo(() => {
        const items: FormNavigationItem[] = [];
        config.right.forEach(section => {
            items.push({
                label: section.label,
                id: section.label,
                status: "empty",
            });
        });
        return items;
    }, [config]);

    const handleClick = (item: FormNavigationItem, index: number) => {
        document.getElementById(toKebabCase(item.label).toLowerCase())?.scrollIntoView({ behavior: "smooth" });
        updateCurrentSection(index);
    }

    console.log("currentSection", currentSection);

    return (
        <StyledStepper orientation='vertical' connector={<CustomConnector />}>
            {items.map((item, index) => (
                <Step className={currentSection === index ? "active" : ""} sx={{ padding: theme.spacing(2), '& .MuiStepLabel-vertical': { padding: 0, borderRadius: 15, } }} key={item.id} active={true}>
                    <StepLabel sx={{ padding: theme.spacing(2) }} onClick={() => handleClick(item, index)} StepIconComponent={formNavigationCircleByStatus(item.status)}>
                        <Box sx={{ cursor: "pointer" }}>{item.label}</Box>
                    </StepLabel>
                </Step>
            ))}
        </StyledStepper>
    );
}



const HormonicalProtocolsForm: React.FC<HormonicalProtocolsFormProps> = (props) => {

    const [uploads, setUploads] = React.useState<File[]>([]);

    const theme = useTheme();

    return (
        <FormProvider>
            <Stack gap={3} direction={"row"}>
                <Box width={"40%"}>
                    <Box sx={{ position: "sticky", top: 0 }}>
                        <CardWithHeader headerColor={"white"} title={""}>
                            <FormNavigation config={config} />
                        </CardWithHeader>
                    </Box>
                </Box>
                <Stack width={"60%"} gap={2}>

                    <FileUploadButton2
                        accept={'.pdf'}
                        onChange={(files: File[]) => setUploads(files)}
                        label={"Upload Bloodwork PDF for Faster Data Entry"}
                        labelWhenFilesSelected={(files: File[]) => `${files.length} file(s) uploaded`}
                    />

                    <Divider variant='middle' sx={{ paddingY: theme.spacing(2) }}>
                        <Typography sx={{ color: "#63635E" }} fontSize={14}>or enter data manually</Typography>
                    </Divider>

                    <AbsForm
                        langCategory='hormoneProtocols'
                        data={{}}
                        system='metric'
                        config={config}
                        initialValues={{}}
                        onSubmit={() => { }}
                        schema={schema}
                        onChange={() => { }}
                    />
                </Stack>
            </Stack>
        </FormProvider>

    );
};

export default HormonicalProtocolsForm;